import React from 'react';
import { Platform } from 'react-native';
let is_angular_cache = null;
export function shouldTransformElementsToRTL(is_rtl) {
    if (!is_rtl || Platform.OS !== 'web') {
        return false;
    }
    if (is_angular_cache !== null) {
        return is_angular_cache;
    }
    const angular_attributes = ['ng-app', 'ng-version', 'ng-controller'];
    is_angular_cache = angular_attributes.some(attr => document.querySelector(`[${attr}]`));
    return is_angular_cache;
}
function transformStyles(style) {
    if (!style) {
        return { value: style, has_change: false };
    }
    if (Array.isArray(style)) {
        let has_change = false;
        const new_style = style.map(style => {
            const value = transformStyles(style);
            if (value.has_change) {
                has_change = true;
            }
            return value.value;
        });
        return { value: new_style, has_change };
    }
    if (typeof style === 'object') {
        let has_change = false;
        if (style.paddingEnd !== undefined) {
            has_change = true;
            style.paddingLeft = style.paddingEnd;
            style.paddingEnd = undefined;
        }
        if (style.paddingStart !== undefined) {
            has_change = true;
            style.paddingRight = style.paddingStart;
            style.paddingStart = undefined;
        }
        if (style.marginEnd !== undefined) {
            has_change = true;
            style.marginLeft = style.marginEnd;
            style.marginEnd = undefined;
        }
        if (style.marginStart !== undefined) {
            has_change = true;
            style.marginRight = style.marginStart;
            style.marginStart = undefined;
        }
        return { value: style, has_change };
    }
    return { value: style, has_change: false };
}
export function transformElementsToRTL(children) {
    return React.Children.map(children, child => {
        if (child && React.isValidElement(child) && typeof child === 'object' && child.props) {
            const new_props = Object.assign({}, child.props);
            let has_change = false;
            if (new_props.style) {
                const result = transformStyles(new_props.style);
                if (result.has_change) {
                    has_change = true;
                    new_props.style = result.value;
                }
            }
            if (new_props.containerStyle) {
                const result = transformStyles(new_props.containerStyle);
                if (result.has_change) {
                    has_change = true;
                    new_props.containerStyle = result.value;
                }
            }
            if (new_props.textStyle) {
                const result = transformStyles(new_props.textStyle);
                if (result.has_change) {
                    has_change = true;
                    new_props.textStyle = result.value;
                }
            }
            if (!has_change) {
                return child;
            }
            return React.cloneElement(child, new_props);
        }
        return child;
    });
}
